module.exports = __webpack_public_path__ + "static/img/6.b1dd6b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6.jpg
// module id = wp/8
// module chunks = 0